// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__TMwQF","form":"Login_form__2mvFD","forgotText":"Login_forgotText__3bHhs","forgotModal":"Login_forgotModal__hOS_n"};